import React from 'react';


import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import { useMediaQuery, useTheme } from '@mui/material';
import { Icon } from 'web-library';
import CancelButton from '../../../../components/buttons/CancelButton';
import SaveButton from '../../../../components/buttons/SaveButton';

const useStyles = makeStyles()((theme) =>
({
  button: {
    padding: `0px 0px 0px ${theme.spacing(4)}`,
    minWidth: 0,
    [theme.breakpoints.down('sm')]: {
      paddingRight: theme.spacing(3),
    },
  },
  buttonsContainer: {
    paddingBottom: theme.spacing(5),
  },
  buttonsHeader: {
    paddingBottom: theme.spacing(0),
  },
  loadingContainer: {
    marginLeft: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(2),
    },
    [theme.breakpoints.up('sm')]: {
      marginBottom: theme.spacing(5),
    },
  },
  mobileEditState: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: theme.spacing(2),
  },
}));

interface ParticularsSaveButtonsProps {
  /**
   * Indicator whether the form is in editing state.
   */
  isEditState: boolean;
  /**
   * Indicator whether it is calling update particular API.
   */
  isLoading: boolean;
  /**
   * Callback method when cancel button clicked.
   */
  cancelHandler: () => void;
  /**
   * Indicator whether it is Non National Exam.
   */
  isHeader?: boolean;
}

const ParticularsSaveButtons = (props: ParticularsSaveButtonsProps) => {
  const { isEditState, isLoading, cancelHandler, isHeader = false } = props;
  const theme = useTheme();
  const { classes } = useStyles();
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (isLoading) {
    return (
      <Icon
        color={theme.color.icon.iconDefault}
        name={IconName.loadingIndicator}
        size="L"
        className={classes.loadingContainer}
      />
    );
  }

  const buttonHeader = isHeader ? classes.buttonsHeader : classes.buttonsContainer;

  return (
    <div className={isMobile && isEditState ? classes.mobileEditState : buttonHeader}>
      <CancelButton
        className={classes.button}
        label={t('components->>IconLabel.Cancel')}
        cancelHandler={cancelHandler}
      />
      <SaveButton className={classes.button} label={t('components->>IconLabel.SaveChanges')} />
    </div>
  );
};

export default ParticularsSaveButtons;
